// extracted by mini-css-extract-plugin
export default {"contentWrapper":"PrivacyPolicyModal_contentWrapper__dnzzf","closeBtn":"PrivacyPolicyModal_closeBtn__6O-5f","cardButton":"PrivacyPolicyModal_cardButton__P-b6E"};